import { render } from "./ElemCostType.vue?vue&type=template&id=2cec7c40&scoped=true"
import script from "./ElemCostType.vue?vue&type=script&lang=js"
export * from "./ElemCostType.vue?vue&type=script&lang=js"

import "./ElemCostType.vue?vue&type=style&index=0&id=2cec7c40&lang=scss&scoped=true"

import exportComponent from "/Users/alexeysorokin/Desktop/hexp2/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cec7c40"]])

export default __exports__